export default __webpack_public_path__ + "static/media/sucess-check.fb0d9af6.svg";